import React from "react";

const CONFIDENCE_LABEL = {
  measured: "Measured",
  estimated: "Estimated",
  simulated: "Simulated",
  manual: "Manual",
  unknown: "Unknown",
};

const STATUS_LABEL = {
  connected: "Connected",
  stale: "Stale",
  error: "Error",
  not_configured: "Not configured",
  disabled: "Disabled",
};

export function ConfidencePill({ level = "unknown", className = "", testid }) {
  const lv = (level || "unknown").toLowerCase();
  return (
    <span
      data-testid={testid || `confidence-pill-${lv}`}
      className={`pill pill-${lv} ${className}`}
    >
      <span className="pill-dot" />
      {CONFIDENCE_LABEL[lv] || lv}
    </span>
  );
}

export function StatusPill({ status = "not_configured", className = "", testid }) {
  const st = (status || "not_configured").toLowerCase();
  return (
    <span
      data-testid={testid || `status-pill-${st}`}
      className={`pill pill-${st} ${className}`}
    >
      <span className="pill-dot" />
      {STATUS_LABEL[st] || st}
    </span>
  );
}
